// Runtime config injected by the Rails layout via a `<script>` tag (or
// optionally via the Vite env at build time). The server-rendered path is
// preferred because rotating the Mapbox token doesn't require a frontend
// rebuild. Empty defaults keep the page functional in tests and in dev
// environments without Mapbox configured.

export interface JdrConfig {
  mapboxToken: string;
}

interface ConfiguredWindow extends Window {
  __JDR_CONFIG__?: Partial<JdrConfig>;
}

export function getConfig(): JdrConfig {
  const w = window as ConfiguredWindow;
  return {
    mapboxToken: w.__JDR_CONFIG__?.mapboxToken ?? ""
  };
}
